import React, { useEffect, useState } from "react";
import APIs from "../../APIs";
import { useNavigate } from "react-router-dom";

const DashboardHeader = () => {
  const navigate = useNavigate();
  const [status, setStatus] = useState({});
  const userData = JSON.parse(sessionStorage.getItem("userData") || "{}");
  const user_id = userData?.user_id;

  useEffect(() => {
     fetchOrders();
     // eslint-disable-next-line react-hooks/exhaustive-deps
   }, []);
 
   const fetchOrders = async () => {
     try {
       if (!user_id) return;
 
       const res = await APIs.post(
         "booking/getDashboard",
         { user_id },
         { headers: { "Content-Type": "application/json" } }
       );
 
       const currentStatus =
         res.data.data.status ||
         res.data.data.status ||
         [];
 
       setStatus(currentStatus);
       console.log("Dashboard currentStatus response:", res.data.data.status);
     } catch (error) {
       console.error("Error fetching status:", error);
       setStatus([]);
     }
   };
  const items = [
    { key: "allOrders", label: "All Orders", icon: "flaticon-parcels" },
    { key: "pendingOrders", label: "Waiting Orders", icon: "flaticon-box" },
    { key: "confirmedOrders", label: "Ongoing Orders", icon: "flaticon-air-plane" },
    { key: "inTransitOrders", label: "Scheduled Orders", icon: "flaticon-delivery-man" },
    { key: "deliveredOrders", label: "Completed Orders", icon: "flaticon-protected" },
    { key: "cancelledOrders", label: "Canceled Orders", icon: "flaticon-box" },
  ];

  return (
    <>
      <a
        className="btn btn-primary d-inline-block mb-4 d-lg-none"
        data-bs-toggle="offcanvas"
        href="#offcanvasExample"
        role="button"
      >
        Show Menu
      </a>

      {/* Order Counts */}
      <div className="row">
        {items.map((item, idx) => (
          <div key={idx} className="col-md-6 col-lg-4">
            <div className="card order-count-wraper mb-3">
              <div className="card-body position-relative">
                <div className="order-count">
                  <div className="align-slef-center">
                    <h4 className="counter text-themecolor">
                      <span className="counter-count">
                        {status[item.key] ?? 0}
                      </span>
                    </h4>
                    <h6 className="mb-0">{item.label}</h6>
                  </div>
                  <div className="order-count-icon">
                    <i className={item.icon}></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

export default DashboardHeader;
